import React from 'react'

import { Paper, Typography, Box, Divider, Button } from '@material-ui/core'

import { Permitted } from 'components/Permissions'
import * as service from 'service'
import constants from './../../../../constants'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import SettingsInvoiceTable from './components/SettingsInvoiceTable'
import SettingsInvoiceForm from './components/SettingsInvoiceForm'

const SettingsInvoice = () => {
  const snackbar = useSnackbar()

  const {
    isLoading: isLoadingContractOverdue,
    response: responseContractOverdue,
    refresh: refreshContractOverdue,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.CONTRACT_OVERDUE,
  })
  const {
    isLoading: isLoadingContractCancelOverdue,
    response: responseContractCancelOverdue,
    refresh: refreshContractCancelOverdue,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.CONTRACT_CANCEL_OVERDUE,
  })
  const {
    isLoading: isLoadingContractCancelPending,
    response: responseContractCancelPending,
    refresh: refreshContractCancelPending,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.CONTRACT_CANCEL_PENDING,
  })
  const {
    isLoading: isLoadingInvoiceInterval,
    response: responseInvoiceInterval,
    refresh: refreshInvoiceInterval,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.INVOICE_INTERVAL,
  })
  const {
    isLoading: isLoadingPaymentMaxSplit,
    response: responsePaymentMaxSplit,
    refresh: refreshPaymentMaxSplit,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.PAYMENT_MAX_SPLIT,
  })
  const {
    isLoading: isLoadingPaymentDaysToGenerate,
    response: responsePaymentDaysToGenerate,
    refresh: refreshPaymentDaysToGenerate,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.PAYMENT_DAYS_TO_GENERATE,
  })
  const {
    isLoading: isLoadingInvoicesGenerationOnOverdue,
    response: responseInvoicesGenerationOnOverdue,
    refresh: refreshInvoicesGenerationOnOverdue,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.INVOICES_GENERATION_ON_OVERDUE,
  })
  const {
    isLoading: isLoadingGenerateFirstInvoiceProportional,
    response: responseGenerateFirstInvoiceProportional,
    refresh: refreshGenerateFirstInvoiceProportional,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_FIRST_INVOICE_PROPORTIONAL,
  })
  const {
    isLoading: isLoadingGenerateProportionalOnOverdue,
    response: responseGenerateProportionalOnOverdue,
    refresh: refreshGenerateProportionalOnOverdue,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_PROPORTIONAL_ON_OVERDUE,
  })
  const {
    isLoading: isLoadingGenerateProportionalOnPause,
    response: responseGenerateProportionalOnPause,
    refresh: refreshGenerateProportionalOnPause,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_PROPORTIONAL_ON_PAUSE,
  })
  const {
    isLoading: isLoadingGenerateProportionalOnDayExpirationChanges,
    response: responseGenerateProportionalOnDayExpirationChanges,
    refresh: refreshGenerateProportionalOnDayExpirationChanges,
  } = useFetch(service.recurrence.settings.get, {
    settingId:
      constants.settings.GENERATE_PROPORTIONAL_ON_DAY_EXPIRATION_CHANGES,
  })
  const {
    isLoading: isLoadingGenerateInvoiceWhenInactivated,
    response: responseGenerateInvoiceWhenInactivated,
    refresh: refreshGenerateInvoiceWhenInactivated,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_INVOICE_WHEN_INACTIVATED,
  })
  const {
    isLoading: isLoadingGenerateProportionalOnUpgrade,
    response: responseGenerateProportionalOnUpgrade,
    refresh: refreshGenerateProportionalOnUpgrade,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_PROPORTIONAL_ON_UPGRADE,
  })
  const {
    isLoading: isLoadingGenerateProportionalOnDowngrade,
    response: responseGenerateProportionalOnDowngrade,
    refresh: refreshGenerateProportionalOnDowngrade,
  } = useFetch(service.recurrence.settings.get, {
    settingId: constants.settings.GENERATE_PROPORTIONAL_ON_DOWNGRADE,
  })

  const isLoading =
    isLoadingContractOverdue ||
    isLoadingContractCancelOverdue ||
    isLoadingContractCancelPending ||
    isLoadingInvoiceInterval ||
    isLoadingPaymentMaxSplit ||
    isLoadingPaymentDaysToGenerate ||
    isLoadingInvoicesGenerationOnOverdue ||
    isLoadingGenerateFirstInvoiceProportional ||
    isLoadingGenerateProportionalOnOverdue ||
    isLoadingGenerateProportionalOnDayExpirationChanges ||
    isLoadingGenerateInvoiceWhenInactivated ||
    isLoadingGenerateProportionalOnUpgrade ||
    isLoadingGenerateProportionalOnDowngrade ||
    isLoadingGenerateProportionalOnPause

  const settings = {
    contractOverdue:
      responseContractOverdue && responseContractOverdue.data.setting,
    contractCancelOverdue:
      responseContractCancelOverdue &&
      responseContractCancelOverdue.data.setting,
    contractCancelPending:
      responseContractCancelPending &&
      responseContractCancelPending.data.setting,
    invoiceInterval:
      responseInvoiceInterval && responseInvoiceInterval.data.setting,
    paymentMaxSplit:
      responsePaymentMaxSplit && responsePaymentMaxSplit.data.setting,
    paymentDaysToGenerate:
      responsePaymentDaysToGenerate &&
      responsePaymentDaysToGenerate.data.setting,
    invoicesGenerationOnOverdue:
      responseInvoicesGenerationOnOverdue &&
      responseInvoicesGenerationOnOverdue.data.setting,
    generateFirstInvoiceProportional:
      responseGenerateFirstInvoiceProportional &&
      responseGenerateFirstInvoiceProportional.data.setting,
    generateProportionalOnOverdue:
      responseGenerateProportionalOnOverdue &&
      responseGenerateProportionalOnOverdue.data.setting,
    generateProportionalOnPause:
      responseGenerateProportionalOnPause &&
      responseGenerateProportionalOnPause.data.setting,
    generateProportionalOnDayExpirationChanges:
      responseGenerateProportionalOnDayExpirationChanges &&
      responseGenerateProportionalOnDayExpirationChanges.data.setting,
    generateInvoiceWhenInactivated:
      responseGenerateInvoiceWhenInactivated &&
      responseGenerateInvoiceWhenInactivated.data.setting,
    generateProportionalOnUpgrade:
      responseGenerateProportionalOnUpgrade &&
      responseGenerateProportionalOnUpgrade.data.setting,
    generateProportionalOnDowngrade:
      responseGenerateProportionalOnDowngrade &&
      responseGenerateProportionalOnDowngrade.data.setting,
  }

  const handleSubmit = async data => {
    try {
      await Promise.all([
        service.recurrence.settings.update({
          settingId: constants.settings.CONTRACT_OVERDUE,
          value: data.contractOverdue,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.CONTRACT_CANCEL_OVERDUE,
          value: data.contractCancelOverdue,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.CONTRACT_CANCEL_PENDING,
          value: data.contractCancelPending,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.INVOICE_INTERVAL,
          value: data.invoiceInterval,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.PAYMENT_MAX_SPLIT,
          value: data.paymentMaxSplit,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.PAYMENT_DAYS_TO_GENERATE,
          value: data.paymentDaysToGenerate,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.INVOICES_GENERATION_ON_OVERDUE,
          value: data.invoicesGenerationOnOverdue,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_FIRST_INVOICE_PROPORTIONAL,
          value: data.generateFirstInvoiceProportional,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_PROPORTIONAL_ON_OVERDUE,
          value: data.generateProportionalOnOverdue,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_PROPORTIONAL_ON_PAUSE,
          value: data.generateProportionalOnPause,
        }),
        service.recurrence.settings.update({
          settingId:
            constants.settings.GENERATE_PROPORTIONAL_ON_DAY_EXPIRATION_CHANGES,
          value: data.generateProportionalOnDayExpirationChanges,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_INVOICE_WHEN_INACTIVATED,
          value: data.generateInvoiceWhenInactivated,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_PROPORTIONAL_ON_UPGRADE,
          value: data.generateProportionalOnUpgrade,
        }),
        service.recurrence.settings.update({
          settingId: constants.settings.GENERATE_PROPORTIONAL_ON_DOWNGRADE,
          value: data.generateProportionalOnDowngrade,
        }),
      ])

      snackbar.open({
        message: 'Configurações de faturamento alteradas com sucesso',
        variant: 'success',
      })

      setEdit(false)

      refreshContractOverdue()
      refreshContractCancelOverdue()
      refreshContractCancelPending()
      refreshInvoiceInterval()
      refreshPaymentMaxSplit()
      refreshPaymentDaysToGenerate()
      refreshInvoicesGenerationOnOverdue()
      refreshGenerateFirstInvoiceProportional()
      refreshGenerateProportionalOnOverdue()
      refreshGenerateProportionalOnPause()
      refreshGenerateProportionalOnDayExpirationChanges()
      refreshGenerateInvoiceWhenInactivated()
      refreshGenerateProportionalOnUpgrade()
      refreshGenerateProportionalOnDowngrade()
    } catch (error) {
      snackbar.open({
        message: 'Erro ao alterar configurações de faturamento',
        variant: 'error',
      })
    }
  }

  const handleClickButtonEdit = () => {
    setEdit(true)
  }

  const handleClose = () => {
    setEdit(false)
  }

  const [edit, setEdit] = React.useState(false)

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Informações de Faturamento</Typography>
        <Permitted tag="update_setting">
          {!edit && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickButtonEdit}
            >
              Editar
            </Button>
          )}
        </Permitted>
      </Box>

      <Divider />

      {!edit && (
        <SettingsInvoiceTable isLoading={isLoading} settings={settings} />
      )}

      {!isLoading && edit && (
        <SettingsInvoiceForm
          settings={settings}
          handleClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </Paper>
  )
}

export default SettingsInvoice
